import { render } from "./ReasignacionManual.vue?vue&type=template&id=08b7ad76"
import script from "./ReasignacionManual.vue?vue&type=script&lang=js"
export * from "./ReasignacionManual.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__